/** Pieces a batch will hold: one per unit, matching createBatch. */
export const piecesOnRow = (item) => {
  const qty = parseInt(item?.quantity, 10) || 0;
  const labels = item?.labelsCount;
  if (typeof labels === "number" && !Number.isNaN(labels)) return qty * labels;
  return qty;
};

export const batchPieceCount = (rows) =>
  (rows || []).reduce((sum, item) => sum + piecesOnRow(item), 0);

export const piecesLabel = (count) => {
  const n = Number(count) || 0;
  if (!n) return "";
  return `${n.toLocaleString()} item${n === 1 ? "" : "s"}`;
};
